// extracted by mini-css-extract-plugin
module.exports = {"oefeningenlijst":"Route-module--oefeningenlijst--xNS5k","omschrijving":"Route-module--omschrijving--19qZ0"};